<template>
  <div>
    <div class="page-title">Edit Video</div>
    <Notice type="info" title="Environment Agnostic">
      Changes here apply to both staging and production — no deployment
      needed.
    </Notice>
    <Form
      v-if="form"
      v-model="form"
      :submit="update"
      btnText="Update Video"
      @destroy="destroy"
    />
    <Spinner v-else />
  </div>
</template>

<script>
import Form from "./_form.videos.page";
export default {
  components: { Form },
  metaInfo() {
    const subject = this.form?.title;
    return {
      title: subject ? `Edit “${subject}”` : `Edit Video`,
    };
  },
  data() {
    return {
      form: null,
    };
  },
  created() {
    this.setForm();
    this.$store.commit("ui/setEnvAgnostic", true);
  },
  beforeDestroy() {
    this.$store.commit("ui/setEnvAgnostic", false);
  },
  methods: {
    async update() {
      await this.$api.Video.update(this.form);
      this.$router.push("/videos");
    },
    async setForm() {
      const { data } = await this.$api.Video.get({
        id: this.$route.params.id,
      });
      this.form = { data: { ctas: [] }, ...data };
    },
    async destroy() {
      const confirmed = await this.$confirmWindow({
        title: "Are you sure?",
      });
      if (!confirmed) return;

      await this.$api.Video.destroy({ id: this.form.id });
      this.$router.push("/videos");
    },
  },
};
</script>

<style></style>
